module.exports = __webpack_public_path__ + "img/search.05523592.svg";